import React from 'react'
import PropTypes from 'prop-types'

const DimensionChartState = ({
  state, value, faded, selected, selectedHandler, span, average, index,
  otherValue, currentValue
}) => {
  const color = selected ? '#404180' : '#6061A0'
  const opacity = faded ? 0.6 : 1
  const percentDiff = 100 * Math.abs(value - average) / span
  const oPercentDiff = 100 * Math.abs(otherValue - average) / span
  const cPercentDiff = 100 * Math.abs(currentValue - average) / span
  const top = (value > average) ? 50 - percentDiff : 50 + percentDiff
  const oTop = (otherValue > average) ? 50 - oPercentDiff : 50 + oPercentDiff
  const cTop = (currentValue > average) ? 50 - cPercentDiff : 50 + cPercentDiff
  const lHeight = Math.abs(Math.max(cTop, oTop) - Math.min(cTop, oTop));
  const lTop = Math.min(cTop, oTop);
  const below = value < average ? true : false;
  return (
    <div
      className={ `cmwf--performance-chart-state ${ faded ? "faded" : "" } ${ below ? "below" : "" }` }
      onClick={() => selectedHandler(state)}
      role="button"
      tabIndex={0}
      style={{
        left: ((100/51) * index) + '%',
        top: ((100/51) * index) + '%',
        height: 100/51 + '%', // 100% / 51 (50 states + DC)
        width: 100/51 + '%', // 100% / 51 (50 states + DC)
      }}
    >
      <div className="cmwf--performance-chart-state-dot dot--baseline"
        style={{
          left: (100 - oTop) + '%',
          top: oTop + '%',
        }}
      />
      <div className="cmwf--performance-chart-state-dot dot--current"
        style={{
          left: (100 - cTop) + '%',
          top: cTop + '%',
        }}
      />
      <div className="cmwf--performance-chart-state-line"
        style={{
          height: lHeight + '%',
          width: lHeight + '%',
          left: (100 - lTop) + '%',
          top: lTop + '%',
        }}
      />
      <div className={ `cmwf--performance-chart-state-dot dot--main ${ selected ? "selected" : "" }`}
        style={{
          // background: color,
          // opacity,
          left: (100 - top) + '%',
          top: top + '%',
        }}
      >
        <span>{state}</span>
      </div>
    </div>
  )
}

DimensionChartState.propTypes = {
  state: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  otherValue: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  faded: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  selectedHandler: PropTypes.func.isRequired,
  span: PropTypes.number.isRequired,
  average: PropTypes.number.isRequired,
}

export default DimensionChartState



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/dimension-chart-state.jsx